export const getters = {
    keyIndicators: state=>state.keyIndicators, 
    sellingPlanPerformanceByCountry: state=>state.sellingPlanPerformanceByCountry, 
};
